import CustomersPage from "./CustomersPage";
import UsersPage from "./UsersPage";
import checkDocumentsPage from "./checkDocumentsPage";
import DepositsPage from "./DepositsPage";
import BlogPage from "./BlogPage";
import NftPage from "./NftPage";
import PreservedAresPage from "./PreservedAresPage";
import LoginPage from "./LoginPage";
import HomePage from "./HomePage";
import ProfilePage from "./ProfilePage";
import EditProfilePage from "./EditProfilePage";
import RefundPage from "./RefundPage";
const pages = {
  CustomersPage,
  UsersPage,
  DepositsPage,
  checkDocumentsPage,
  BlogPage,
  PreservedAresPage,
  LoginPage,
  HomePage,
  ProfilePage,
  EditProfilePage,
  NftPage,
  RefundPage,
};
export default pages;
